import { render, staticRenderFns } from "./FormulaMixNutrition.vue?vue&type=template&id=444e0513&scoped=true"
import script from "./FormulaMixNutrition.vue?vue&type=script&lang=js"
export * from "./FormulaMixNutrition.vue?vue&type=script&lang=js"
import style0 from "./FormulaMixNutrition.vue?vue&type=style&index=0&id=444e0513&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e0513",
  null
  
)

export default component.exports